<template>
  <div>
    <div class="app-title">
      <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
    </div>
    <section class="app-content" v-menu-permission="'list'">
      <div id="accordionFilter" class="content">
        <div class="card">
          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
               data-parent="#accordionFilter">
            <div class="card-body">
              <form>
                <em-filter :entity="modelName" ref="emListFilter"
                           :query-api="'findRecordsFor'+pageName"
                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"></em-filter>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div id="sithMesInventoryReceiptReturnRecordResultTable" class="content">
        <div class="card my-1">
          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
               data-parent="#accordionResult">
            <div class="card-body">
              <em-table :entity="modelName"
                        withCustomRowActions
                        ref="emTable" :inlineActionsDisabled="prop_inline!=='1'"
                        :query-api="'findRecordsFor'+pageName"
                        @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                        @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow">
                <template #left-header>
                  <em-button v-if="show104"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="通知物流104"
                             showName
                             :disabled="actionDisabled('selectOne')"
                             @click="open104Dialog()"
                  >
                  </em-button>
                  <em-button v-if="show105"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="105"
                             showName
                             :disabled="actionDisabled('selectOne')"
                             @click="open105Dialog()"
                  >
                  </em-button>
                  <em-button v-if="show105"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="批量105"
                             showName
                             :disabled="actionDisabled('selectMulti')"
                             @click="openBatch105Dialog()"
                  >
                  </em-button>

                  <em-button v-if="show105"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="扫码识别"
                             showName
                             @click="openScannerDialog()"
                  >
                  </em-button>
                  <em-button v-if="show106"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="106"
                             showName
                             :disabled="actionDisabled('selectOne')"
                             @click="open106Dialog()"
                  >
                  </em-button>
                  <em-button v-if="show101Failed"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="匹配已收货PO-ITEM"
                             showName
                             :disabled="actionDisabled('selectOne')"
                             @click="matchPoItem()"
                             :busy="onMatching"
                             confirm-text="该操作将从到货列表匹配PO-ITEM"
                  >
                  </em-button>
                  <em-button v-if="show101Failed"
                             type='search'
                             class="btn btn-outline-primary btn-sm"
                             custom-label="101收货"
                             showName
                             :disabled="actionDisabled('select')"
                             @click="receive101()"
                             :busy="onReceiving101"
                             confirm-text="确认执行101?"
                  >
                  </em-button>
                </template>
                <template #customRowActions="{row}">
                  <b-button-group>
                    <em-button type="gotoChild"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="gotoPackingMaterial(row)">
                    </em-button>
                    <em-button type="gotoChild"
                               v-if="handleShow106Record(row) && show106"
                               customLabel="查看106记录"
                               v-bind:class="'btn btn-outline-primary btn-sm'"
                               @click="find106Data(row)">
                    </em-button>
                  </b-button-group>
                </template>
              </em-table>
            </div>
          </div>
        </div>
      </div>
    </section>
    <re-b-modal ref="record106" header= '106退货详情'
                no-close-on-backdrop
                fit-content
                large
                @hide="triggerHide">
      <div class="d-flex flex-column h-100 position-relative">
        <mini-table ref="record106Table"
                    class="flex-grow-1 overflow-auto"
                    entity-name="sithMesInventoryReceiptReturnRecord"
                    :items="recordOf106"
                    :fields="[]"
                    :total-count="totalCount"
                    read-only sortable
                    enable-pagination
                    disable-first-index-column
                    need-model-fields
                    @pageChange="whenPageChange">
        </mini-table>
      </div>
    </re-b-modal>
    <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal='false' append-to-body @close='clearQuantity'>
      <el-form ref="operationForm" :model="quantityForm" label-width="auto" style="width:35%;margin-top:15px;">
        <el-form-item :label="formLabel">
          <el-input v-if="!showBatch105ItemNo" v-model="quantityForm.quantity" clearable type="number"></el-input>
          <span v-if="showBatch105ItemNo" v-text="quantityForm.quantity"></span>
        </el-form-item>
        <el-form-item v-if="showBatch105ItemNo" label="本次批量过105的条目数量">
          <span v-text="batch105ItemNo"></span>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="quantityForm.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="checkQuantity()" @click="confirm()">确认</el-button>
      </div>
    </el-dialog>
    <el-dialog title="扫一扫" :center="true" :visible.sync="scannerVisible" append-to-body @close="closeScannerDialog"
               :close-on-click-modal='false'>
      <qr-code-scanner ref="recordScanner" @getCodeData='getRecordOf103'>
      </qr-code-scanner>
    </el-dialog>
  </div>
</template>
<script>
// Author Lin
// Date 2021-08-27 10:02:26

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";
import qrCodeScanner from "@/components/QRCode/QRCodeScannerForInventory";
import emCommonGotoMixin from "@/mixin/em/common/goto";
import emTableCheckedMixin from "@/mixin/em/common/stuffs/table/emTableCheckedMixin";
import ReBModal from "@/components/echarts-part/CalendarShift/cells/stuffs/ReBModal.vue";
import MiniTable from "@/components/common/mini-table/MiniTable.vue";

export default {
  components: {MiniTable, ReBModal, qrCodeScanner},
  name: "sithMesInventoryReceiptReturnRecordListView",
  mixins: [emCommonListMixin, emCommonApiMixin, emCommonGotoMixin, emTableCheckedMixin],
  props: {
    //是否启用行编辑
    prop_inline: {
      type: String,
      default: "0"
    },
    pageName: {
      type: String,
    }
  },
  data() {
    return {
      show104: false,
      show105: false,
      show106: false,
      max : {
        type:Number,
      },
      show106RecordButton : false,
      recordOf106 :[],
      totalCount :0,
      page: {
        pageNumber: 1,
        pageSize: 10,
      },
      row : [],
      show101Failed: false,
      processing: false,
      dialogTitle: '',
      dialogVisible: false,
      quantityForm: {
        quantity: '',
        remark: '',
      },
      formLabel: '',
      //当前dialog对应的动作
      currentOperation: '',
      scannerVisible: false,
      onMatching: false,
      onReceiving101: false,
      showBatch105ItemNo: false,
      batch105ItemNo: Number(0),
    }
  },
  computed: {
    modelName() {
      return 'sithMesInventoryReceiptReturnRecord'
    },
    checkedItems() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"];
      // return this.$refs.emTable.checkedItems
    },
    selectIds() {
      //这里要注意，如果filter和table使用了customVuex，这里要用checkedItems拼装首字母开头的customVuex name。不使用$refs.emTable是因为初始化时取不到，会报错
      return this.$store.state[this.modelName]["checkedItems"].join(",");
    },
  },
  watch: {
    pageName() {
      this.$nextTick(() => {
        this.setButtonStatus(this.pageName);
        this.$refs.viewTitle.getMenuTitleData();
        this.$refs.emListFilter.doQuery();
      });
    }
  },
  methods: {
    triggerHide() {
      this.recordOf106 = [];
    },
    handleShow106Record(row) {
      return Number(row.returnQuantity) > 0;
    },
    whenPageChange(page,row) {
      this.page = page;
      this.doQuery(row);
    },
    showEdit(row) {
      this.row = row;
      this.doQuery(row);
      this.$refs.record106.showModal();
    },
    setButtonStatus(pageName) {
      if (pageName == '103') {
        this.show104 = true;
        this.show105 = true;
        this.show106 = false;
      } else if (pageName == '105') {
        this.show104 = false;
        this.show105 = false;
        this.show106 = true;
      } else if (pageName == '101Failed') {
        this.show101Failed = true;
      } else if (pageName == '104') {
        this.show104 = false;
        this.show105 = false;
        this.show106 = false;
      } else {
        return;
      }
    },
    //根据按钮上设置的选中类型和实际列表中选中的项目，判断按钮是否可点
    actionDisabled(type) {
      // 删除按钮在一条记录都没选的时候禁用
      if (type === "select") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length === 0;
        return this.checkedItems && this.checkedItems.length === 0;
      }
      // 编辑按钮只在选择了1条记录的时候可用，其他情况下禁用
      else if (type === "selectOne") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length !== 1;
      }
      // 批量105按钮只在选择了多条记录的时候可用，其他情况下禁用
      else if (type === "selectMulti") {
        // return this.$refs.emTable.checkedItems && this.$refs.emTable.checkedItems.length !== 1;
        return this.checkedItems && this.checkedItems.length <= 1;
      }
    },
    open104Dialog() {
      this.dialogVisible = true;
      this.dialogTitle = '通知物料做104';
      this.formLabel = '需要做104的数量';
      this.currentOperation = '104';
    },
    open105Dialog() {
      this.dialogVisible = true;
      this.dialogTitle = '过105';
      this.formLabel = '本次过105数量';
      this.currentOperation = '105';
      this.quantityForm.quantity = this.checkedRows[0].receiptQuantity;
    },
    openBatch105Dialog() {
      this.dialogVisible = true;
      this.dialogTitle = '过105';
      this.formLabel = '本次批量过105数量';
      this.currentOperation = 'batch105';
      this.showBatch105ItemNo = true;
      this.batch105ItemNo = this.checkedRows.length;
      let number = 0.0;
      for (let i = 0; i < this.checkedRows.length; i++) {
        let inputQuantity = this.checkedRows[i].receiptQuantity;
        if (!isNaN(inputQuantity)) {
          number += (Number(inputQuantity) * 10) / 10;
        }
      }
      this.quantityForm.quantity = number.toFixed(1);
    },
    open106Dialog() {
      this.dialogVisible = true;
      this.dialogTitle = '退106';
      this.formLabel = '退106数量';
      this.currentOperation = '106';
    },
    checkQuantity() {
      let inputQuantity = this.quantityForm.quantity;
      if (inputQuantity === '' || inputQuantity == null || isNaN(inputQuantity) || inputQuantity <= 0) {
        return true;
      } else {
        return false;
      }
    },
    clearQuantity() {
      this.quantityForm.quantity = '';
      this.quantityForm.remark = '';
      this.currentOperation = '';
      this.formLabel = '';
      this.showBatch105ItemNo = false;
      this.batch105ItemNo = Number(0);
    },
    notifyLogistics() {
      this.processing = true;

    },
    confirm() {
      let self = this;
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/`;
      if (self.currentOperation === '104') {
        url += `notifyLogistics?id=${self.selectIds}&quantity=${self.quantityForm.quantity}`
      } else if (self.currentOperation === '105') {
        url += `do105?id=${self.selectIds}&quantity=${self.quantityForm.quantity}&remark=${self.quantityForm.remark}`
      } else if (self.currentOperation === 'batch105') {
        url += `doBatch105?ids=${self.selectIds}&quantity=${self.quantityForm.quantity}&remark=${self.quantityForm.remark}`
      } else if (self.currentOperation === '106') {
        url += `do106?id=${self.selectIds}&quantity=${self.quantityForm.quantity}&remark=${self.quantityForm.remark}`
      } else {
        self.$message({
          message: "无法确认操作类型",
          type: "error",
        });
        self.dialogVisible = false;
      }

      self.$_emApiMixin_post(url, self.recordsToReturn)
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "处理成功",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "处理失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            self.dialogVisible = false;
          });
    },
    openScannerDialog() {
      this.scannerVisible = true;
      setTimeout(() => {
        this.$refs.recordScanner.openCamera('');
      }, 500);
    },
    getRecordOf103(data) {
      console.log("get qr code data:" + data);
      this.scannerVisible = false;
      let self = this;
      //检验二维码的数据格式
      try {
        var obj = JSON.parse(data);
        var poNumber = obj.PO;
        var item = obj.PoItem;
        console.log(poNumber);
        console.log(item);
      } catch (error) {
        self.$message({
          message: "无效的二维码",
          type: "error",
        });
        return;
      }
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('purchaseNumberFilter', poNumber);
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('itemCodeFilter', item);
      this.$refs.emListFilter.doQuery();
    },
    closeScannerDialog() {
      this.$refs.recordScanner.closeCamera();
      this.$refs.recordScanner.resetOutputData();
      this.scannerVisible = false;
    },
    gotoPackingMaterial(row) {
      this.$_emGotoMixin_gotoHolderList("sithMesInventoryPackingBom"
          , {itemIdFilter: row.poitemId}
          , {itemId: row.poitemId}, true, {})
    },
    find106Data(row) {
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/findRecordsFor106?parentId=${row.id}`;
      this.$_emApiMixin_post(url, {})
          .then((response) => {
                if (response instanceof Object) {
                  if (response.data.list.length === 0) {
                    this.$message({
                      message: "无106退货记录！(2023年11月3号后的数据才会生成退货记录)",
                      type: "error",
                    });
                  } else {
                    this.recordOf106 = response.data.list
                    this.totalCount = response.data.pagination.totalReg
                    this.$refs.record106.showModal();
                  }
                }
          })
    },
    matchPoItem() {
      let self = this;
      self.onMatching = true;
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/matchPoItem?id=${self.selectIds}`;
      self.$_emApiMixin_post(url, {})
          .then((request) => {
            if (request.status === 200) {
              self.$message({
                message: "匹配结束",
                type: "success",
              });
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "匹配失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            self.onMatching = false;
          });
    },
    receive101() {
      let self = this;
      self.onReceiving101 = true;
      let url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryReceiptReturnRecord")}/receive101?ids=${self.selectIds}`;
      self.$_emApiMixin_post(url, {})
          .then((request) => {
            if (request.status === 200) {
              // 逐条收货，部分失败时列出失败原因，成功的条目已经落库
              const {successCount = 0, failedMessages = []} = request.data || {};
              if (failedMessages.length === 0) {
                self.$message({
                  message: `收货完成，共${successCount}条`,
                  type: "success",
                });
              } else {
                self.$message({
                  message: `成功${successCount}条，失败${failedMessages.length}条：${failedMessages.join('；')}`,
                  type: "warning",
                  duration: 0,
                  showClose: true,
                });
              }
              self.$refs.emListFilter.doQuery();
            } else {
              self.$message({
                message: "收货失败",
                type: "error",
              });
            }
          })
          .finally(() => {
            self.onReceiving101 = false;
          });
    }
  },
  created() {
    this.setButtonStatus(this.pageName);
  },
  mounted() {
    if (this.$route.query.hasOwnProperty("poItemId")) {
      this.$refs.emListFilter.$_emCustomVuexMixin_setFilterAttribute('poitemIdFilter', this.$route.query.poItemId);
      this.$refs.emListFilter.doQuery();
    }
  },
};
</script>
